import {ForgotPasswordResendToken} from 'domain/usecases';
import {RemoteForgotPasswordResendToken} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {EntryFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeForgotPasswordResendToken = (): ForgotPasswordResendToken =>
	new RemoteForgotPasswordResendToken(
		makeBFFApiUrl(EntryFlowEndPoints.forgotReSendToken),
		makeAuthorizeHttpClientDecorator(),
	);
